import * as Sentry from "@sentry/react";

const { VITE_SENTRY_ENVIRONMENT: SENTRY_ENVIRONMENT } = import.meta.env;

const PACKAGE_NAME = process.env.npm_package_name
const PACKAGE_VERSION = process.env.npm_package_version
const COMMIT_HASH = process.env.RENDER_GIT_COMMIT

export const setupSentry = (): void => {
  Sentry.init({
    dsn: "https://d16d3d25ac134d689de5f495aa03c372@o793342.ingest.sentry.io/5801370",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    environment: SENTRY_ENVIRONMENT,
    release: `${PACKAGE_NAME}@${PACKAGE_VERSION}:${COMMIT_HASH}`,

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
    
    // Session Replay
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}
